//handles redux exhibitor state
import {createSlice} from '@reduxjs/toolkit';

const initialStateValue = ''

export const userSlice = createSlice({
    name:"user",
    initialState:{value:initialStateValue},
    reducers:{
        rxUser:(state,action)=>{
            state.value = action.payload
        },
    }
})

export const {rxUser} = userSlice.actions

export default userSlice.reducer;
